import { render, staticRenderFns } from "./vFormCreationForm.vue?vue&type=template&id=e461a502&"
import script from "./vFormCreationForm.vue?vue&type=script&lang=js&"
export * from "./vFormCreationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports